import { render, staticRenderFns } from "./BlackPages.vue?vue&type=template&id=dc6ef09c&"
import script from "./BlackPages.vue?vue&type=script&lang=js&"
export * from "./BlackPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports